<template>
	<div>
		<div class="pgemnt-1">
			<div class="tbs">
				<el-table :data="showArr" style="width: 100%">
					<el-table-column label="名称" width="360">
						<template slot-scope="scope">
							<span class="goDeeper" @click="preFmate(scope.row)">
								<span :style="'margin-left:' + 24 * scope.row.x.length + 'px'">
									<span style="margin-left:-18px;" v-if="scope.row.items && scope.row.items.length > 0">
										<i class="el-icon-caret-right" v-if="scope.row.hide"></i>
										<i class="el-icon-caret-bottom" v-else></i>
									</span>
									{{ scope.row.name }}
								</span>

								<span class="tbIcon" v-if="scope.row.items && scope.row.items.length > 0">( {{
									scope.row.items.length }} )</span>
							</span>
						</template>
					</el-table-column>
					<el-table-column label="排序" width="180">
						<template slot-scope="scope">
							<span class="goDeeper">{{ scope.row.sort }}</span>
						</template>
					</el-table-column>
					<el-table-column label="查询码" width="180">
						<template slot-scope="scope">
							<span class="goDeeper">{{ scope.row.code }}</span>
						</template>
					</el-table-column>
					<el-table-column align="right" label="操作">
						<template slot="header">
							<el-button class="newAdd" type="primary" size="mini" @click="btnTrans('add')">新增</el-button>
						</template>
						<template slot-scope="scope">
							<el-button v-if="scope.row.level == null" type="primary" @click="btnTrans('add', scope.row)"
								size="mini">添加</el-button>
							<el-button type="danger" @click="btnTrans('edit', scope.row)" size="mini">编辑</el-button>
							<el-button type="warning" @click="btnTrans('remove', scope.row)"
								:disabled="scope.row.items && scope.row.items.length > 0" size="mini">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<el-dialog :title="diaTitle" @close="closeHandle" class="pgemnt-1-dag" :visible.sync="diaForAdd" width="450px"
				:close-on-click-modal="false" center>
				<table>
					<tr>
						<td class="inpName">
							<div>名称：</div>
						</td>
						<td>
							<div class="inContent">
								<el-input size="medium" v-model="postDats.name"></el-input>
							</div>
						</td>
					</tr>
					<tr>
						<td class="inpName">
							<div>排序：</div>
						</td>
						<td>
							<div class="inContent">
								<el-input size="medium" v-model="postDats.sort"></el-input>
							</div>
						</td>
					</tr>
					<tr v-if="pstate">
						<td class="inpName">
							<div>查询码：</div>
						</td>
						<td>
							<div class="inContent">
								<el-input size="medium" v-model="postDats.code"></el-input>
							</div>
						</td>
					</tr>
				</table>
				<span slot="footer" class="dialog-footer">
					<el-button @click="diaForAdd = false" size="small">取 消</el-button>
					<el-button type="primary" @click="goSave()" size="small">确 定</el-button>
				</span>
			</el-dialog>
		</div>
	</div>
</template>

<script>
import { dictCreate, getDistTree, dictRemove } from '@/api/pgMent/dictMent';
export default {
	data() {
		return {
			tableData: [],
			storeArr: [],
			showArr: [],

			pstate: false,

			//  弹出层

			diaForAdd: false,
			diaTitle: '',

			postDats: {
				id: '',
				parentId: '',
				name: '',
				sort: '',
				code: ''
			},

		}
	},
	methods: {
		goDeeper: function (dats) {
			// console.log(dats);
		},

		formateDat: function (dats, inx) {
			for (let i in dats) {
				let Item = dats[i];
				console.log('Item:' + JSON.stringify(Item));
				if (inx) {
					let tmp = [i];
					Item.x = inx.concat(tmp);
				} else {
					Item.x = [i];
				}
				Item.hide = true;
				this.storeArr.push(Item);
				if (Item.items && Item.items.length > 0) {
					this.formateDat(Item.items, Item.x);
				}
			}
		},

		arrEquires: function (arr1, arr2) {

			let eqs = true;
			for (let i in arr1) {
				if (arr1[i] != arr2[i]) {
					eqs = false;
					break;
				}
			};

			return eqs;

		},

		preFmate: function (rows) {
			// console.log('rows:' + JSON.stringify(rows));
			if (rows.hide) {
				rows.hide = false;
				this.showFormate('open', rows.x);
			} else {
				rows.hide = true;
				this.showFormate('close', rows.x);
			}
		},

		showFormate: function (state, iArr) {
			// console.log('storeArr:' + this.storeArr);
			// console.log('state:' + state);
			// console.log('iArr:' + iArr);
			// iArr 被点击行的 root 数组
			// state 执行 code

			let tempArr = [];
			for (let i in this.storeArr) {
				let item = this.storeArr[i];
				// console.log('item:' + item);
				if (state == "init") {
					if (item.x && item.x.length == 1) {
						tempArr.push(item);
					}
				} else {
					if (this.arrEquires(iArr, item.x)) {
						if (item.x.length - iArr.length == 1) {
							tempArr.push(item);
						}
					}
				}
			}

			if (state == "open") {
				for (let i in this.showArr) {
					let item = this.showArr[i];
					if (this.arrEquires(iArr, item.x) && iArr.length == item.x.length) {
						this.showArr.splice((parseInt(i) + 1), 0, ...tempArr);
						break;
					}
				}
			} else if (state == "close") {
				let transArr = [];
				for (let i in this.showArr) {
					let toAdd = true;
					for (let j in tempArr) {
						if (this.arrEquires(tempArr[j].x, this.showArr[i].x)) {
							toAdd = false;
							break;
						}
					};
					if (toAdd) {
						transArr.push(this.showArr[i]);
					}
				};

				this.showArr = transArr;
			} else if (state == "init") {
				this.showArr = tempArr;
			}
		},
		goSave: function () {
			let msg = '';
			if (!this.postDats.name) {
				msg = '请填写名称！';
			} else if (!this.postDats.sort && this.postDats.sort != 0) {
				msg = '请填写排序！';
			}

			if (msg) {
				this.$message({
					showClose: true,
					message: msg,
					type: 'error'
				})
			} else {
				dictCreate({ dataDictionary: this.postDats }).then(response => {
					this.diaForAdd = false;
					this.$message({
						showClose: true,
						message: '操作成功！',
						type: 'success'
					});
					this.$emit('go-frash');
					this.dictGet();
				})
			}

		},

		goRemove: function (dat) {

			this.$confirm('确定要删除该节点吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消'
			}).then(() => {
				let posts = {
					id: dat.id
				}
				dictRemove(posts).then(response => {
					this.$message({
						showClose: true,
						message: '删除成功！',
						type: 'success'
					});
					this.$emit('go-frash');
					this.dictGet();
				})
			})
		},

		btnTrans: function (state, dat) {
			if (state == "add") {
				this.diaForAdd = true;
				this.diaTitle = "添加";
				if (dat) {
					this.postDats.parentId = dat.id;
				} else {
					this.pstate = true;
				}

			} else if (state == "edit") {
				this.diaForAdd = true;
				this.diaTitle = "编辑";
				this.postDats = {
					id: dat.id,
					parentId: dat.parentId,
					name: dat.name,
					sort: dat.sort,
					code: dat.code
				};

				if (!dat.parentId) {
					this.pstate = true;
				}
			} else if (state == "remove") {
				this.goRemove(dat);
			}
		},

		dictGet: function () {
			let that = this;
			getDistTree().then(response => {
				that.tableData = response.dataDictionaryTreeModules;
				that.formateDat(that.tableData);
				that.showFormate("init");
			})
		},

		menuCreate: function () {
			getMenu().then(response => {
				console.log(response);
				this.tableData = response.getMenuTreeModules;
				this.formateDat(this.tableData);
				this.showFormate("init");
			});
		},

		closeHandle: function () {
			this.postDats.id = '';
			this.postDats.name = '';
			this.postDats.sort = '';
			this.postDats.code = '';
			this.postDats.parentId = '';

			this.pstate = false;
			console.log('aaa');
		}

	},
	created: function () {
		// this.menuCreate();
		this.dictGet();
	}
}

</script>

<style lang="scss">
.pgemnt-1 {
	padding: 6px 30px;
}

.pgemnt-1 .goDeeper {
	cursor: pointer;
}

.pgemnt-1-dag .el-dialog__header {
	padding: 20px 18px 25px;
}

.pgemnt-1-dag .el-dialog__body {
	padding: 0px 30px;
	margin-bottom: 12px;
}

.pgemnt-1-dag .el-dialog__footer {
	padding-bottom: 30px;
}

.pgemnt-1-dag table {
	width: 100%;
	margin-top: 12px;
}

.pgemnt-1-dag table td {
	padding-bottom: 12px;
}

.pgemnt-1-dag .inContent {
	padding-right: 12px;
}

.pgemnt-1 .inpName {
	text-align: right;
	width: 90px;
	padding-right: 6px;
}


.pgemnt-1 .inpGup {
	margin-bottom: 12px;
	height: 45px;
	background: salmon;
}

.pgemnt-1 .newAdd {
	width: 90px;
}
</style>



// WEBPACK FOOTER //
// dictMent.vue?74e76d40